import React, { useEffect, useRef, useState } from "react";
import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyCarts } from "../../redux/reducer/cartReducer";
import { getProductItemById } from "../../redux/reducer/productReducer";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const CartButton = ({ notification, role }) => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigateWithLang = useLanguageNavigate();

  const [direction, setDirection] = useState(
    localStorage.getItem("language") === "en" ? "rtl" : "ltr"
  );
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const { allProducts, productsLoading, productsError } = useSelector(
    (state) => state.products
  );
  const { carts, cartsLoading, cartsError } = useSelector(
    (state) => state.carts
  );

  const pendingProducts =
    allProducts?.filter((product) => product.status === "pending") || [];
  const pendingCount = pendingProducts.length;

  const pendingOrPricedCarts =
    carts?.filter(
      (cart) => cart.status === "pending" || cart.status === "priced"
    ) || [];

  const Buy_For_Me_Count = pendingOrPricedCarts.length;

  // console.log(carts)
  useEffect(() => {
    if (role === "customer") {
      dispatch(fetchMyCarts());
      if (carts.length === 0) {
        dispatch(getProductItemById());
      }
    }
  }, [dispatch]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const language = localStorage.getItem("language");
    setDirection(language === "ar" ? "rtl" : "ltr");
  }, [localStorage.getItem("language")]);

  const handleClick = () => {
    navigateWithLang("/my-account/buy-for-me");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block group">
      <ShoppingCartIcon
        className={`lg:w-7 w-6 lg:h-7 h-6 ${
          pendingCount > 0 || Buy_For_Me_Count > 0
            ? "text-red-400"
            : "text-white"
        }  duration-300 group-hover:text-custom-yellow cursor-pointer`}
        onClick={handleClick}
      />
      {Buy_For_Me_Count > 0 ? (
        <span className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-xs font-bold text-red-400 duration-300 bg-black rounded-full group-hover:text-custom-yellow">
          {Buy_For_Me_Count}
        </span>
      ) : pendingCount > 0 ? (
        <span className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-xs font-bold text-red-400 duration-300 bg-black rounded-full group-hover:text-custom-yellow">
          {pendingCount}
        </span>
      ) : null}
    </div>
  );
};

export default CartButton;
